import {css} from "styled-components";
import styled from "@yb/styled-px2rem";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";

interface Props extends ButtonProps {
	text?: string;
	size?: "default" | "submit";
	types?: "base" | "basic" | "confirm" | "emp" | "gray";
	width?: "basic" | "full";
	onClick?: () => void;
}

const StyledButton = styled.button<Props>`
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--bl-color);
	background-color: #fff;
	color: var(--emp-color);
	font-size: 15px;
	font-family: "PT-regular";
	font-weight: normal;
	white-space: nowrap;
	box-sizing: border-box;
	overflow: hidden;
	letter-spacing: -0.07em;

	${props => {
		if (props.types === "basic") {
			return css`
				border-color: transparent;
				background-color: var(--default-color);
				color: #fff;
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "confirm") {
			return css`
				border-color: transparent;
				background-color: var(--yellow-color);
				color: var(--emp-color);
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "emp") {
			return css`
				border-color: transparent;
				background-color: var(--emp-color);
				color: #fff;
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "gray") {
			return css`
				background: #eee;
				color: var(--gray-color);
				cursor: unset;
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
	}}

	${props =>
		props.size === "default"
			? css`
					height: 40px;
			  `
			: css`
					height: 50px;
					font-size: 18px;
					font-weight: bold;
					letter-spacing: -0.05em;
			  `}
    
    ${props =>
		props.width === "basic"
			? css`
					padding: 0 20px;
			  `
			: css`
					width: 100%;
			  `}
`;

const TextButton = ({text, ...props}: Props) => (
	<StyledButton type="button" {...props}>
		{text}
	</StyledButton>
);

export default TextButton;
